const htmlToCanvas = require('html2canvas')

module.exports = () => {
  return new Promise(resolve => {
    htmlToCanvas(document.body).then(canvas => {
      return resolve(canvas.toDataURL('image/png'))
    })
  })
}
